import { render, staticRenderFns } from "./ItensREView.vue?vue&type=template&id=67ddf644&scoped=true"
import script from "./ItensREView.vue?vue&type=script&lang=js"
export * from "./ItensREView.vue?vue&type=script&lang=js"
import style0 from "./ItensREView.vue?vue&type=style&index=0&id=67ddf644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ddf644",
  null
  
)

export default component.exports